import React from 'react';
import PropTypes from 'prop-types';
import Header from './header';
import Banner from './banner';
import Footer from './footer';
import CookiesPolicies from './cookiespolicies';
import './style.scss';

const Layout = ({ children = null, showHeader = true, showBanner = true, showFooter = true, showContent = true }) => {
    return (
        <>
        {showContent && showHeader && <Header />}
        {showContent && showBanner && <Banner />}
        {showContent && children}
        {showContent && showFooter && <Footer />}
        <CookiesPolicies />
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node, 
    showHeader: PropTypes.bool, 
    showBanner: PropTypes.bool, 
    showFooter: PropTypes.bool, 
    showContent: PropTypes.bool
};
export default Layout;